import React from 'react';
import { Link } from 'react-router-dom';

// HaulLogix Shield Logo Component
const HaulLogixLogo = () => (
  <svg width="32" height="36" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="footerShieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="50%" stopColor="#22C55E" />
        <stop offset="100%" stopColor="#3B82F6" />
      </linearGradient>
      <linearGradient id="footerInnerGlow" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#60A5FA" />
        <stop offset="100%" stopColor="#4ADE80" />
      </linearGradient>
    </defs>
    <path d="M18 2L4 8V18C4 28 18 38 18 38C18 38 32 28 32 18V8L18 2Z" fill="url(#footerShieldGradient)"/>
    <path d="M18 6L8 10V18C8 25 18 33 18 33C18 33 28 25 28 18V10L18 6Z" fill="#0D1B2A"/>
    <path d="M12 14V26M12 20H24M24 14V26" stroke="url(#footerInnerGlow)" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-[#0A1628] border-t border-[#3B82F6]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <HaulLogixLogo />
              <span className="text-xl font-bold tracking-tight">
                <span className="text-white">Haul</span><span className="text-[#4ADE80]">Logix</span>
              </span>
            </Link>
            <p className="text-[#94A3B8] text-sm max-w-md leading-relaxed">
              The premium, verified loadboard for professional auto transport and freight.
              If it's not verified, it's not HaulLogix.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-semibold uppercase tracking-wider text-sm mb-5 text-[#60A5FA]">Platform</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/loadboard" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Find Loads
                </Link>
              </li>
              <li>
                <Link to="/backlot" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Backlot Forum
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold uppercase tracking-wider text-sm mb-5 text-[#60A5FA]">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#94A3B8] hover:text-white text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#3B82F6]/20 mt-10 pt-10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748B] text-sm">
            © {new Date().getFullYear()} HaulLogix. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-[#4ADE80]/15 text-[#4ADE80] border border-[#4ADE80]/30">
              Verified Platform
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
